import {Link} from 'react-router-dom';
import {Button} from 'components';

interface IBillingHeaderProps {
  icon: any;
  name: string;
  text: string;
  buttonText: string;
  buttonUrl: string;
}

const BillingHeader = ({icon: Icon, name, text, buttonText, buttonUrl}: IBillingHeaderProps) => {
  return (
    <div className="relative overflow-hidden rounded-lg bg-white dark:bg-slate-900 px-4 pt-5 pb-12 shadow-sm sm:px-6 sm:pt-6">
      <dt className="mb-1">
        <div className="absolute rounded-md border border-slate-500 dark:border-darkText p-3">
          <Icon aria-hidden="true" className="size-6 text-slate-500 dark:text-darkText" />
        </div>
        <p className="ml-16 truncate text-sm font-medium text-gray-500 dark:text-darkText">{name}</p>
      </dt>
      <dd className="ml-16 flex items-baseline pb-6 sm:pb-7">
        <p className="text-sm mb-3 truncate font-semibold text-gray-900 dark:text-white">{text}</p>
        <div className="absolute inset-x-0 bottom-0 bg-gray-50 dark:bg-slate-800 px-4 py-4 sm:px-6">
          <Link to={buttonUrl} className="inline-flex">
            <Button text={buttonText} size="extra-small" />
          </Link>
        </div>
      </dd>
    </div>
  );
};

export default BillingHeader;
